import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { OrganizationKey, UserOrganization, UserOrganizationConfig } from '../models';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  private selectedOrganizationSubject = new BehaviorSubject<UserOrganization | null>(null);
  selectedOrganization$ = this.selectedOrganizationSubject.asObservable();

  constructor(private auth: AuthService, private http: HttpClient) { }

  setSelectedOrganization(organization: UserOrganization) {
    this.selectedOrganizationSubject.next(organization);
  }

  getSelectedOrganization() {
    return this.selectedOrganizationSubject.value;
  }

  getOrganizationById(id: number) {
    return this.http.get<UserOrganizationConfig>(`${environment.urlApi}/organizations/${id}`);
  }

  editOrganization(organization: UserOrganizationConfig) {
    return this.http.put(`${environment.urlApi}/organizations/${organization.id}`, organization);
  }

  getTokensByOrganizationId(organizationId: number) {
    return this.http.get<OrganizationKey[]>(`${environment.urlApi}/organizations/${organizationId}/apikeys`);
  }

  saveToken(organizationId: number, key: OrganizationKey) {
    return this.http.post(`${environment.urlApi}/organizations/${organizationId}/apikeys`, key);
  }

  updateToken(organizationId: number, keyId: string, body: { name: string, expirationDays: number }) {
    return this.http.put(`${environment.urlApi}/organizations/${organizationId}/apikeys/${keyId}`, body);
  }

  deleteToken(organizationId: number, keyId: string) {
    return this.http.delete(`${environment.urlApi}/organizations/${organizationId}/apikeys/${keyId}`);
  }



  }
